import { createApp } from "vue";
import router from "./router/index";
import { createPinia } from "pinia";
import App from "./App.vue";
import { Quasar } from "quasar";
import { checkEnvironment } from "./utils/capacitor";
import { initSentry } from "./utils/sentry";
import { config as quasarConfig } from "./utils/quasar";
import { checkPageUpdate } from "./utils/autoUpdate";
import { getAppInfo } from "./utils/capacitor/appPlugin";
// import { checkAppUpdate } from "./utils/capacitor/appPlugin";

import "quasar/dist/quasar.css";
import "@/assets/styles/font.less";
import "@/assets/styles/quasar.scss";
import "@quasar/extras/material-icons/material-icons.css";

// 最后导入 Tailwind CSS，使其具有更高优先级
import "@/assets/styles/tailwind.css";

checkEnvironment(); // 检查环境
checkPageUpdate(); // 检查页面更新
// checkAppUpdate(); // 检查app更新
getAppInfo();

export const app = createApp(App);

// 初始化 sentry
initSentry(app);

app.use(createPinia()).use(router).use(Quasar, quasarConfig).mount("#app");
